import gql from "graphql-tag"

const COPY_ORDER_FUNERAL_INFO_MEMORY_ROOM = gql`
  mutation CopyOrderFuneralInfoToMemoryRoom($id: ID!) {
    copyOrderFuneralInfoToMemoryRoom(orderId: $id)
  }
`

export default COPY_ORDER_FUNERAL_INFO_MEMORY_ROOM
